import React from "react";
import {useRouter} from "next/router";
import {useCountryLang} from "../hooks/useCountryLang";
import {request} from "../shared/httpInterceptor";

// Controls if the account migration logic was already handled for this session. This is to avoid duplicate handling.
const storageParamName: string = "accountMigrationHandled";

function migrateAccount(countryLang: string, msl: any) {
  //No need to wait for the result. Account clone is automatic, there's nothing to show on the frontend
  request({
    url: `/${countryLang}/newsletter/cloneAccount/${msl}`,
    method: 'post',
  })
}

const AccountMigration = () => {
  const countryLang = useCountryLang();
  const router = useRouter()
  const msl = router.query.msl;

  if (typeof window !== "undefined" && countryLang && msl) {
    const accountMigrationHandled = localStorage.getItem(storageParamName)

    if (!accountMigrationHandled) {
      localStorage.setItem(storageParamName, "true");
      migrateAccount(countryLang, msl);
    }
  }


  return (
    <></>
  )
}

export default AccountMigration;